import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'nameInitials',
  standalone: true
})
export class NameInitialsPipe implements PipeTransform {

  transform(value: string): string {
    if (!value) return '';
    const words = value.trim().split(/\s+/);
    const initials = words.slice(0, 2).map(word => word.charAt(0).toUpperCase()).join('');
    return initials;
  }

}
